var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicenses(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9677_33301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6621 2.5V5.83333C11.6621 6.05435 11.7499 6.26631 11.9062 6.42259C12.0625 6.57887 12.2744 6.66667 12.4954 6.66667H15.8288",
    stroke: "#0699CE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16211 6.66667V4.16667C4.16211 3.72464 4.3377 3.30072 4.65026 2.98816C4.96283 2.67559 5.38675 2.5 5.82878 2.5H11.6621L15.8288 6.66667V15.8333C15.8288 16.2754 15.6532 16.6993 15.3406 17.0118C15.0281 17.3244 14.6041 17.5 14.1621 17.5H9.99544",
    stroke: "#0699CE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.666C2.5 12.3291 2.76339 12.9649 3.23223 13.4338C3.70107 13.9026 4.33696 14.166 5 14.166C5.66304 14.166 6.29893 13.9026 6.76777 13.4338C7.23661 12.9649 7.5 12.3291 7.5 11.666C7.5 11.003 7.23661 10.3671 6.76777 9.89825C6.29893 9.42941 5.66304 9.16602 5 9.16602C4.33696 9.16602 3.70107 9.42941 3.23223 9.89825C2.76339 10.3671 2.5 11.003 2.5 11.666Z",
    stroke: "#0699CE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 14.166L2.5 18.3327L5 17.0827L7.5 18.3327L6.25 14.166",
    stroke: "#0699CE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9677_33301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenses);
export default __webpack_public_path__ + "static/media/licenses.ff837697bc53b718b77718b124e32d31.svg";
export { ForwardRef as ReactComponent };